// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
// ┃ ██████ ██████ ██████       █      █      █      █      █ █▄  ▀███ █       ┃
// ┃ ▄▄▄▄▄█ █▄▄▄▄▄ ▄▄▄▄▄█  ▀▀▀▀▀█▀▀▀▀▀ █ ▀▀▀▀▀█ ████████▌▐███ ███▄  ▀█ █ ▀▀▀▀▀ ┃
// ┃ █▀▀▀▀▀ █▀▀▀▀▀ █▀██▀▀ ▄▄▄▄▄ █ ▄▄▄▄▄█ ▄▄▄▄▄█ ████████▌▐███ █████▄   █ ▄▄▄▄▄ ┃
// ┃ █      ██████ █  ▀█▄       █ ██████      █      ███▌▐███ ███████▄ █       ┃
// ┣━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┫
// ┃ Copyright (c) 2017, the Perspective Authors.                              ┃
// ┃ ╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌ ┃
// ┃ This file is part of the Perspective library, distributed under the terms ┃
// ┃ of the [Apache License 2.0](https://www.apache.org/licenses/LICENSE-2.0). ┃
// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛

import { RegularTableElement } from "regular-table";
import getCellConfig from "../get_cell_config.js";
import type { DatagridModel, PerspectiveClickDetail } from "../types.js";
import type { HTMLPerspectiveViewerElement } from "@perspective-dev/viewer";

export function createDispatchClickListener(
    model: DatagridModel,
    table: RegularTableElement,
    viewer: HTMLPerspectiveViewerElement,
    plugin: HTMLElement,
): EventListener {
    return async (event: Event): Promise<void> => {
        const mouseEvent = event as MouseEvent;
        const meta = table.getMeta(mouseEvent.target as HTMLElement);
        if (!meta || meta.type !== "body") {
            return;
        }

        if (model._edit_mode === "SELECT_ROW_TREE") {
            return;
        }

        const { x, y } = meta;
        const { row, column_names, config } = await getCellConfig(model, y, x);
        const panel = plugin.getAttribute("slot") ?? undefined;
        viewer.dispatchEvent(
            new CustomEvent<PerspectiveClickDetail>("perspective-click", {
                bubbles: true,
                composed: true,
                detail: {
                    row,
                    column_names,
                    config,
                    panel,
                },
            }),
        );
    };
}
